module.exports = __webpack_public_path__ + "static/media/lana-del-rey-icon.f7070d1d.jpg";